import { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null=checking, false=guest, object=user
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("dmi_token");
    if (!token) {
      setUser(false);
      setLoading(false);
      return;
    }
    api
      .get("/auth/me")
      .then((res) => setUser(res.data))
      .catch(() => {
        localStorage.removeItem("dmi_token");
        setUser(false);
      })
      .finally(() => setLoading(false));
  }, []);

  const login = async (email, password, portal) => {
    const { data } = await api.post("/auth/login", { email, password });
    const isAdmin = data.user.role === "admin";
    if (portal && (portal === "admin") !== isAdmin) {
      const err = new Error("wrong_portal");
      err.wrongPortal = true;
      throw err;
    }
    localStorage.setItem("dmi_token", data.token);
    setUser(data.user);
    return data.user;
  };

  const logout = () => {
    localStorage.removeItem("dmi_token");
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, logout, setUser }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
